export enum CallSchemaType {
    INBOUND = "Входящая", OUTBOUND = "Исходящая", AUTOCALL = "Кампания"
}
